/*
inicia gráfico
*/

import { Scatter } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
  ScatterController,
  ChartOptions,
  ChartData,
  Point,
  TooltipItem,
  ChartEvent,
  ActiveElement,
} from 'chart.js'

// Register Chart.js modules
ChartJS.register(LinearScale, PointElement, Title, Tooltip, Legend, ScatterController)

interface PointEx extends Point {
  tooltip: string[]
  id: string
}
const DealChart: React.FC<{ dataAtrasado: PointEx[]; dataAtiempo: PointEx[]; onPointClick: (id: string) => void }> = ({
  dataAtrasado,
  dataAtiempo,
  onPointClick,
}) => {
  // Define scatter plot data
  const chartData: ChartData<'scatter'> = {
    datasets: [
      {
        label: 'Atrasados',
        data: dataAtrasado,
        backgroundColor: 'rgba(245, 7, 7, 1)', // Point color
        pointRadius: 10, // Size of points
      },
      {
        label: 'A tiempo',
        data: dataAtiempo,
        backgroundColor: 'rgb(9, 107, 79)', // Point color
        pointRadius: 10, // Size of points
      },
    ],
  }

  // Define scatter plot options
  const options: ChartOptions<'scatter'> = {
    responsive: true,
    scales: {
      x: {
        type: 'linear',
        position: 'bottom',
        title: {
          display: true,
          text: 'Precio  vehículo (Millones de $)',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Atraso (días)',
        },
      },
    },
    plugins: {
      title: {
        display: true,
        text: 'Negocios',
      },
      tooltip: {
        enabled: true,
        callbacks: {
          label: (tooltipItem: TooltipItem<'scatter'>) => {
            const dataset = tooltipItem.dataset

            if (dataset && dataset.data) {
              const aux = dataset.data as PointEx[]

              return aux[tooltipItem.dataIndex].tooltip
            }
          },
        },
      },
    },
    onClick: (_event: ChartEvent, elements: ActiveElement[]) => {
      if (elements.length > 0) {
        const chart = elements[0]
        const datasetIndex = chart.datasetIndex
        const dataIndex = chart.index
        const clickedPoint = chartData.datasets[datasetIndex].data[dataIndex] as PointEx

        onPointClick(clickedPoint.id)
      }
    },
  }

  return <Scatter data={chartData} options={options} />
}
export default DealChart
